export const VUE_INITIALIZED_APP_SELECTOR = '.js-vue-init';
export const VUE_APPS_SELECTOR = `.js-vue-app:not(${VUE_INITIALIZED_APP_SELECTOR})`;

const isHasDevtoolsVariable = Object.prototype.hasOwnProperty.call(window.specialtyApp.settings, 'VUE_DEVTOOLS_DISABLED');
Vue.config.devtools = isHasDevtoolsVariable ? !window.specialtyApp.settings.VUE_DEVTOOLS_DISABLED : false;

/**
 * Инициализирует vue-приложения на элементах, заданных в VUE_APPS_SELECTOR
 */
export function initVueApps() {
    const elements = document.querySelectorAll(VUE_APPS_SELECTOR);

    elements.forEach((el) => {
        el.classList.add(VUE_INITIALIZED_APP_SELECTOR.replace('.', ''));
        // eslint-disable-next-line
        new Vue({
            el,
            provide() {
                return {
                    $basketService: window.specialtyApp?.basketService,
                    $favoritesService: window.specialtyApp?.favoritesService,
                    $userGeoService: window.specialtyApp?.userGeoService,
                };
            },
            ...window.vueData,
        });
    });
}
